import React, { createContext, useState, ReactNode } from 'react';

interface ShopItem {
    id: number;
    price: number;
    image: string;
    name: string;
    position: {
        top: string;
        left: string;
        width: string;
        height: string;
    };
}

interface GameContextProps {
    score: number;
    setScore: React.Dispatch<React.SetStateAction<number>>;
    purchasedItems: ShopItem[];
    purchaseItem: (item: ShopItem) => void;
}

export const GameContext = createContext<GameContextProps | undefined>(undefined);

interface GameProviderProps {
    children: ReactNode;
}

export const GameProvider: React.FC<GameProviderProps> = ({ children }) => {
    const [score, setScore] = useState(0);
    const [purchasedItems, setPurchasedItems] = useState<ShopItem[]>([]);

    const purchaseItem = (item: ShopItem) => {
        setPurchasedItems(prev => [...prev, item]);
        setScore(prev => prev - item.price);
    };

    return (
        <GameContext.Provider value={{ score, setScore, purchasedItems, purchaseItem }}>
            {children}
        </GameContext.Provider>
    );
};